import { useEffect, useRef } from 'react';
import { Button } from '@/components/DesignSystem/AtomicComponents';
import { OtpRightArrow } from '@/assets/svgExports/OtpRightArrow';
import styles from '../MemberLogin.module.scss';
import useIsComponentMounted from '@/utils/useIsComponentMounted';
import { sendWhatsappMessage } from '@/utils/sendWhatsappMessage';

const MobileView = (props) => {
  const mobileNumberInputRef = useRef();
  const otpInputRef = useRef();
  const isComponentMounted = useIsComponentMounted();

  useEffect(() => {
    if (isComponentMounted) {
      mobileNumberInputRef?.current?.focus();
      otpInputRef?.current?.focus();
      document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
      return () => {
        document.getElementsByTagName('body')[0].style.overflowY = 'auto';
      };
    }
  }, [isComponentMounted]);

  const handleMobileInputChange = (e) => {
    props.handleInputChange(
      'phone',
      e.target.value.replace(/[^0-9]/g, ''),
      'alpha_numeric',
      1,
      10
    );
  };

  const handleOtpInputChange = (e) => {
    props.handleInputChange(
      'otp',
      e.target.value.replace(/[^0-9]/g, ''),
      'alpha_numeric',
      1,
      4
    );
  };

  const onContactUsClick = () => {
    sendWhatsappMessage(`Hi ${props?.storeInfo?.store_name},\n
                         I'm unable to access your website
                         ${props?.storeInfo?.store_url}`);
  };

  return (
    <div className={styles.mobileView}>
      {props.OTPsent ? (
        <>
          <div>
            {isComponentMounted ? (
              <img src={props?.storeInfo?.logo_image} height="40px" width="40px" />
            ) : null}
            <p className="mv0 pt16px f16px fw6 c393939">
              Welcome to {props.storeInfo?.store_info?.name}
            </p>
            <div className="flex items-end justify-between">
              <p className="mv0 f14px fw5 black-color pt34px">
                OTP sent to {props.phone}
              </p>
              <p className="mv0 f12px fw5 c2F80ED" onClick={props.toggleOTPsent}>
                Change number?
              </p>
            </div>
          </div>
          <div className="relative">
            <input
              className={
                props.invalidOtp ? styles.formControlOtpInvalid : styles.formControlOtp
              }
              value={props.OTP}
              ref={otpInputRef}
              placeholder="Enter 4 Digit OTP"
              onChange={handleOtpInputChange}
            />
            {!props.isTimeUp ? (
              <p className={styles.timerInProgress}>{`0:${props.timer}`}</p>
            ) : null}
            {props.isTimeUp && (
              <div className={styles.timerUp}>
                <p className="c6C6C6C mv0 f12px">Did not receive OTP?</p>
                <p
                  className="mv0 fw7 pt4px f12px pointer"
                  onClick={() => props.resendOTP()}
                >
                  Send OTP
                </p>
              </div>
            )}
            {props.invalidOtp ? <p className={styles.invalidOtp}>Invalid OTP</p> : null}
            <div className="relative">
              <Button
                backgroundColor={
                  props.OTP.length === 4 && !props.invalidOtp ? '#000000' : '#00000033'
                }
                roundness={props.storeInfo?.theme?.roundness}
                fluid={true}
                py="15px"
                mt="129px"
                pr="4rem"
                pl="3rem"
                fontSize={18}
                style={{ borderRadius: 100, borderWidth: '0px' }}
                isDisable={props.OTP.length !== 4}
                onClick={() => props.submitVerifyOTP()}
                label="Verify"
              />
              <div
                style={{ position: 'absolute', top: '34%', right: '36%' }}
                onClick={() => props.submitVerifyOTP()}
              >
                <OtpRightArrow />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div>
            {isComponentMounted ? (
              <img src={props?.storeInfo?.logo_image} height="40px" width="40px" />
            ) : null}
            <p className="mv0 pt16px f16px fw6 c393939">
              Welcome to {props.storeInfo?.store_info?.name}
            </p>
            <p className="mv0 f14px fw5 black-color pt34px">Login using Mobile Number</p>
          </div>
          <div className="relative">
            <input
              className={styles.formControl}
              value={props.phone}
              ref={mobileNumberInputRef}
              placeholder="Enter your mobile Number"
              onChange={handleMobileInputChange}
            />
            {props.memberOnlyAccessError ? (
              <div className="flex items-start absolute" style={{ top: 70 }}>
                <img src="/assets/images/red-info-icon.svg" width="12px" height="12px" />
                <p className="mv0 f12px fw4 pl10px" style={{ color: '#F54C52' }}>
                  Sorry, you don’t have permission to access this website.
                </p>
              </div>
            ) : null}
          </div>
          <div style={{ marginTop: 94 }}>
            <div className="relative">
              <Button
                backgroundColor={
                  props.phone.length === 10 && !props.memberOnlyAccessError
                    ? '#000000'
                    : '#00000033'
                }
                roundness={props.storeInfo?.theme?.roundness}
                fluid={true}
                style={{ borderRadius: '2rem', borderWidth: '0px' }}
                py="15px"
                pr="3rem"
                fontSize={18}
                isDisable={
                  (props.phone && props.phone.length !== 10) ||
                  !props.phone ||
                  props.memberOnlyAccessError
                }
                onClick={() => props.setPhoneNumber()}
                label="Get OTP"
              />
              <div
                style={{ position: 'absolute', top: '34%', right: '36%' }}
                onClick={() => props.setPhoneNumber()}
              >
                <OtpRightArrow />
              </div>
            </div>
            <p className="c464646 f12px fw5 mv0 tc pt16px">
              For any query,{' '}
              <button
                className="c2F80ED"
                style={{ border: 'none', cursor: 'pointer', backgroundColor: 'white' }}
                onClick={onContactUsClick}
              >
                Contact us
              </button>
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default MobileView;
